export default __webpack_public_path__ + "static/media/koi.f52c64ae.png";